var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clarity:nvme-line",
    clipPath: "url(#clip0_21_190)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.25 43.3889V27.6111C53.25 26.565 52.8344 25.5617 52.0947 24.822C51.355 24.0822 50.3517 23.6667 49.3056 23.6667H21.6944C20.6483 23.6667 19.645 24.0822 18.9053 24.822C18.1656 25.5617 17.75 26.565 17.75 27.6111V43.3889C17.75 44.435 18.1656 45.4383 18.9053 46.178C19.645 46.9178 20.6483 47.3333 21.6944 47.3333H49.3056C50.3517 47.3333 51.355 46.9178 52.0947 46.178C52.8344 45.4383 53.25 44.435 53.25 43.3889ZM21.6944 27.6111H49.3056V43.3889H21.6944V27.6111Z",
    fill: "#FCB450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.4722 11.8333H45.3611V15.7778H37.4722V11.8333Z",
    fill: "#FCB450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.3253 11.8333H53.2106V15.7778H49.3253V11.8333Z",
    fill: "#FCB450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.4389 15.7778H33.2714V11.8333H11.577L15.3439 8.04667C15.5288 7.86332 15.6755 7.64519 15.7756 7.40486C15.8757 7.16453 15.9273 6.90675 15.9273 6.64639C15.9273 6.38603 15.8757 6.12825 15.7756 5.88792C15.6755 5.64758 15.5288 5.42946 15.3439 5.24611C14.9744 4.87878 14.4745 4.6726 13.9535 4.6726C13.4325 4.6726 12.9326 4.87878 12.5631 5.24611L3.94446 13.8056L12.5631 22.4833C12.9326 22.8507 13.4325 23.0568 13.9535 23.0568C14.4745 23.0568 14.9744 22.8507 15.3439 22.4833C15.7112 22.1138 15.9174 21.6139 15.9174 21.0929C15.9174 20.5719 15.7112 20.072 15.3439 19.7025L11.4389 15.7778Z",
    fill: "#FCB450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.3974 48.6744C58.0279 48.3071 57.5281 48.1009 57.007 48.1009C56.486 48.1009 55.9861 48.3071 55.6166 48.6744C55.4318 48.8578 55.285 49.0759 55.1849 49.3162C55.0848 49.5566 55.0332 49.8144 55.0332 50.0747C55.0332 50.3351 55.0848 50.5929 55.1849 50.8332C55.285 51.0735 55.4318 51.2917 55.6166 51.475L59.3638 55.2222H37.4722V59.1667H59.5611L55.6166 63.1111C55.2493 63.4806 55.0431 63.9805 55.0431 64.5015C55.0431 65.0226 55.2493 65.5224 55.6166 65.8919C55.984 66.2563 56.4798 66.4617 56.9972 66.4639C57.2567 66.4654 57.514 66.4156 57.7543 66.3175C57.9946 66.2193 58.2132 66.0747 58.3974 65.8919L67.0555 57.2931L58.3974 48.6744Z",
    fill: "#FCB450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.6389 55.2222H33.5278V59.1667H25.6389V55.2222Z",
    fill: "#FCB450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.75 55.2222H21.6353V59.1667H17.75V55.2222Z",
    fill: "#FCB450"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.65304573a87830a4d1f06db24b338c00.svg";
export { ForwardRef as ReactComponent };